/**
 * useTodoOperations — CRUD operations for todo items within goals.
 */
import { useTodoCoreOperations } from "./core/todoCore";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";
import { logger } from '@/utils/logger';

export const useTodoOperations = (
  addCloudTodo: any,
  toggleCloudTodo: any,
  invalidateGoals: () => Promise<void>,
  supabaseClient: typeof supabase
) => {
  const { user } = useAuth();
  const { addTodo, toggleTodo, deleteTodo } = useTodoCoreOperations(addCloudTodo, toggleCloudTodo);

  return {
    addTodo,
    toggleTodo,
    deleteTodo: (params: { goalTitle: string; todoId: string }) => 
      deleteTodo(params, async ({ todoId }: { todoId: string }) => {
        if (!user) {
          logger.error("[TodoOperations] User must be authenticated");
          throw new Error("User must be authenticated");
        }
        
        logger.debug(`[TodoOperations] Deleting todo with ID: ${todoId}`);
        
        // Using optimized query approach
        const { error } = await supabaseClient
          .from('todos')
          .delete()
          .eq('id', todoId);
          
        if (error) {
          logger.error(`[TodoOperations] Error deleting todo:`, error);
          throw error;
        }
        
        logger.debug(`[TodoOperations] Todo deleted successfully, invalidating goals cache`);
        await invalidateGoals();
        
        return { success: true, todoId };
      })
  };
};
